module.exports = __webpack_public_path__ + "static/media/GridChart.977d7852.svg";